import { ANALYTICS_EVENT_NAMES } from "analytics/catalog/events";
import { buildCommonEventProps } from "analytics/core/commonProps";
import { trackEvent } from "analytics/core/tracker";

export type HomeAnalyticsContext = {
  pathname: string;
  search: string;
  businessId?: string | null;
  userId?: string | null;
  userEmail?: string | null;
  planType?: string | null;
  currency?: string | null;
};

const buildHomeProps = (context: HomeAnalyticsContext): Record<string, unknown> => {
  return buildCommonEventProps({
    screenKey: "home",
    pathname: context.pathname,
    search: context.search,
    businessId: context.businessId ?? null,
    userId: context.userId ?? null,
    userEmail: context.userEmail ?? null,
    planType: context.planType ?? null,
    currency: context.currency ?? null,
  });
};

export const trackHomeInviteCreatorsClicked = (
  context: HomeAnalyticsContext,
): void => {
  trackEvent(
    ANALYTICS_EVENT_NAMES.homeInviteCreatorsClicked,
    buildHomeProps(context),
  );
};

export const trackHomeCreateCampaignClicked = (
  context: HomeAnalyticsContext,
): void => {
  trackEvent(
    ANALYTICS_EVENT_NAMES.homeCreateCampaignClicked,
    buildHomeProps(context),
  );
};
